import {install} from "vue3-recaptcha-v2"

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(install, {
        sitekey: "6Ld919wiAAAAAAVr6ACuqdZ7dFAodg1jIHHaR-IA",
        cnDomains: false,
    })
})